var map = {
	"./QAList.svg": "QSs5",
	"./QAconfiguration.svg": "N7fQ",
	"./QAmanagement.svg": "OCtj",
	"./activityArrangement.svg": "nnEV",
	"./archiveConfig.svg": "g4hV",
	"./archiveManage.svg": "mZ4C",
	"./audioContent.svg": "0kwC",
	"./careIntervention.svg": "nHJ3",
	"./childrenArchive.svg": "QFxD",
	"./childrenStatic.svg": "qAzw",
	"./classroomManage.svg": "UfSx",
	"./contentManagement.svg": "4tJe",
	"./contentReview.svg": "CwCY",
	"./courseManage.svg": "23Yj",
	"./departmentManagement.svg": "ePPX",
	"./dictionary.svg": "YRIb",
	"./distribute.svg": "nse/",
	"./earlyLearningActivity.svg": "mAv+",
	"./earlyLearningActivityLibrary.svg": "o4JM",
	"./employeeManage.svg": "/zg1",
	"./evaluateList.svg": "XVO3",
	"./evaluateManagement.svg": "P13P",
	"./evaluateStatic.svg": "XJA7",
	"./eye-close.svg": "m3M2",
	"./eye.svg": "4wdf",
	"./faceCrouse.svg": "iiy/",
	"./familyArchive.svg": "T1ob",
	"./formList.svg": "DOXN",
	"./graphicContent.svg": "aKLK",
	"./graphicGuideConfig.svg": "K2XW",
	"./groupActivity.svg": "EgDw",
	"./groupActivityLibrary.svg": "IlNk",
	"./groupActivityList.svg": "9Mid",
	"./guidanceContent.svg": "Zdez",
	"./home.svg": "U9Ws",
	"./hospitalManagement.svg": "J4QX",
	"./hospitalWarehouse.svg": "RcHr",
	"./interventionGuidance.svg": "gQBI",
	"./interventionTraining.svg": "1rQi",
	"./interventionTrainingLibrary.svg": "VhwQ",
	"./liveStreamingManage.svg": "LF1E",
	"./mechanismManagement.svg": "al1g",
	"./miniProgramManage.svg": "svDS",
	"./operationLog.svg": "6VRL",
	"./operationManagement.svg": "W6zG",
	"./platformKnowledgeBase.svg": "W9Sa",
	"./platformLibrary.svg": "ivOA",
	"./platformStandardLibrary.svg": "D/18",
	"./problemIntervention.svg": "cBuS",
	"./problemInterventionLibrary.svg": "szjR",
	"./product-comment.svg": "b5pz",
	"./promotionPositionConfig.svg": "zCbC",
	"./recommend.svg": "rtce",
	"./reportStatic.svg": "wqJO",
	"./resource.svg": "Y1Ub",
	"./role.svg": "cqqK",
	"./scheduleManage.svg": "oEpU",
	"./suggestionTemplate.svg": "UGko",
	"./sys.svg": "zQA3",
	"./sysCategory.svg": "qXpB",
	"./tagManage.svg": "IrbC",
	"./taskList.svg": "3YKW",
	"./taskManage.svg": "4Aky",
	"./teacherManage.svg": "c55c",
	"./videoContent.svg": "Mwdt",
	"./videoCoursesManage.svg": "iy9m",
	"./workPlatform.svg": "7aU8",
	"./workSpace.svg": "Vo8y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 78